import type { ActivityActionType } from "../../lib/api/types";

/** Colored pill: Opened (blue tint) / Downloaded (green tint) — PRD §5.3. */
export function ActionPill({ action }: { action: ActivityActionType }) {
  const isOpen = action === "open";
  return (
    <span
      className={[
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        isOpen ? "bg-brand-50 text-brand-700" : "bg-success-50 text-success-700",
      ].join(" ")}
    >
      {isOpen ? "Opened" : "Downloaded"}
    </span>
  );
}
